import { AfterViewChecked, AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonHelper } from '@app/shared/helpers/common.helper';
import { SharedService } from '@app/services/shared.service';
import { RBACModel } from '@app/models/rbac/rbac.model';
import { UserManagementConstant } from '@app/constant/user-management.constant';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit, AfterViewChecked, AfterViewInit {

  @ViewChild('sidenav') public sidenav: MatSidenav;
  @HostListener('window:scroll', ['$event']) getScrollHeight(event: any): void {
    this.sharedService.setScrollingValue(window.pageYOffset);
  }
  modelIdentity: RBACModel;
  modelUserAccess = UserManagementConstant.AccessGroupAllowed;
  headerChange: boolean = false;
  footerChange: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private cmHelper: CommonHelper,
    private router: Router,
    private msalService: MsalService,
    private sharedService: SharedService) { }

  ngOnInit(): void {
    localStorage.setItem('token_name', 'username');
  }

  ngAfterViewChecked(): void {
    this.headerChange = this.cmHelper.changeHeaderHeightURL(this.router.url);
  }

  ngAfterViewInit() {
    this.sharedService.getRbacAccess().subscribe((rbacAccess) => {
      if (rbacAccess) {
        this.modelIdentity = rbacAccess;
        this.afterViewInit();
      }
    })
  }

  afterViewInit() {
    if (this.modelIdentity === null) {
      this.signout();

    } else {
      let res = this.modelIdentity.party[0].accessGroup.filter(a =>
        this.modelUserAccess.some(b => b.value === a.accessGroupName.toUpperCase())
      );
      let findGroup = this.modelUserAccess.find(x => x.value.toUpperCase() === res[0].accessGroupName.toUpperCase());
      if (findGroup) {
        sessionStorage.setItem('myim', findGroup.name);

        if (sessionStorage.getItem('isLoggedIn') === null) { sessionStorage.setItem('isLoggedIn', 'true'); }

        if (this.router.url === '/' || this.router.url.includes('id_token=')) {
          const userRole = sessionStorage.getItem('myim');
          this.router.navigateByUrl(userRole.includes('MYIM_SINCS') ? 'failure/sdashboard' : 'failure/fdashboard');
        }
      } else {
        this.signout();
      }
    }
  }
  signout() {
    localStorage.removeItem('token_name');
    this.msalService.logout();
    sessionStorage.clear();
    localStorage.clear();
  }
}
